import checkOverflow from "./tableOverflowText";

const accordion = () => {
    const pagination = document.querySelectorAll('.accordion-pagination__item');

    pagination.forEach((button) => {
        button.addEventListener('click', (e) => {
            const btn = e.currentTarget;
            const targetName = btn.getAttribute('data-target');
            const btnWrapper = btn.parentNode;
            const target = document.querySelector('[data-id="' + targetName + '"]');
            const targetWrapper = target.parentNode;

            //Clear active target
            targetWrapper.querySelectorAll('.is-active').forEach((el) => {
                el.classList.remove('is-active');
                el.removeAttribute('style');
            });

            //Set new active target
            target.classList.add('is-active');

            //Clear active button
            btnWrapper.querySelectorAll('.is-active').forEach((el) => {
                el.classList.remove('is-active');
            });

            //Set new active button
            btn.classList.add('is-active');

            //refresh overflow state
            checkOverflow();

            //set height to match current content
            if (target.classList.contains('faq-group-wrapper')) {
                targetWrapper.style.height = target.scrollHeight + 'px';
            }
        });
    });
}

export default accordion;